import { AnyAction } from '@reduxjs/toolkit';

import { State } from '../types/state.interface';

export const initialState: State = {};

export const authReducer = (state = initialState, _action: AnyAction) => {
  return state;
};
